import React from 'react';

import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';

import { useTranslation } from 'next-i18next';

import DialogTitle from 'src/components/ui/DialogTitle';
import Typography from 'src/components/ui/Typography';
import Button from 'src/components/ui/Button';

import type { RatingsQuery } from 'src/types/__generated__/graphql';
import { useHideRatingMutation } from 'src/hooks/__generated__/queries';
import { styledComponent } from 'src/utils/styled';

const StyledDialogTitle = styledComponent(DialogTitle)`
    padding-top: 1.5rem;
`;

type RatingType = NonNullable<ArrayElement<NonNullable<RatingsQuery['ratings']>['allRatings']>>;

interface Props {
    rating: RatingType;
    onClose: () => void;
}

const HideUnhideRatingModal: React.FC<Props> = ({ rating, onClose }) => {
    const { t } = useTranslation(['edit-profile', 'common']);
    const [hideRating] = useHideRatingMutation();

    const handleClose = () => {
        onClose();
    };

    const handleHideIcon = async (id: string, isHidden = false) => {
        onClose();
        await hideRating({
            variables: {
                id: rating.id,
                isHidden,
            },
            refetchQueries: ['Ratings'],
            awaitRefetchQueries: true,
        });
    };

    return (
        <Box width="31rem">
            <Box pl="0.50rem">
                <StyledDialogTitle onClose={handleClose}>
                    <Typography variant="h2">
                        {rating.isHidden
                            ? t('edit-profile:unHideRatingModalTitle')
                            : t('edit-profile:hideRatingModalTitle')}
                    </Typography>
                </StyledDialogTitle>
            </Box>
            <Box width="31rem" height="2.5rem" mt="-0.75rem">
                <DialogContent>
                    <Typography color="dark">
                        {rating.isHidden ? t('edit-profile:unHideRatingModal') : t('edit-profile:hideRatingModal')}
                    </Typography>
                </DialogContent>
            </Box>
            <Box mt="2.5rem" mb="1rem" pr="0.75rem">
                <DialogActions>
                    <Box mr="0.5rem">
                        <Button variant="outlined" onClick={handleClose}>
                            {t('common:cancel')}
                        </Button>
                    </Box>
                    {rating.isHidden ? (
                        <Button onClick={() => handleHideIcon(rating.id, false)}>{t('common:signUp.unHide')}</Button>
                    ) : (
                        <Button onClick={() => handleHideIcon(rating.id, true)}>{t('common:signUp.hide')}</Button>
                    )}
                </DialogActions>
            </Box>
        </Box>
    );
};

export default HideUnhideRatingModal;
